import { render, staticRenderFns } from "./mr_popover.vue.js?vue&type=template&id=be258d42!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mr_popover.vue?vue&type=template&id=be258d42"
import script from "./mr_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mr_popover.vue?vue&type=script&lang=js"
export * from "./mr_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mr_popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be258d42')) {
      api.createRecord('be258d42', component.options)
    } else {
      api.reload('be258d42', component.options)
    }
    module.hot.accept("./mr_popover.vue.js?vue&type=template&id=be258d42!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mr_popover.vue?vue&type=template&id=be258d42", function () {
      api.rerender('be258d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "issuable/popover/components/mr_popover.vue"
export default component.exports